define('atlas/AtlasControls', ['atlas/AtlasClientCapabilities'], function(AtlasClientCapabilities) {

    'use strict';

    var AtlasControls = function(domElement, controlAdapter, dragElement, hideCursor) {
        this._domElement = domElement;
        this._dragElement = dragElement || domElement;
        this._hideCursor = !!(hideCursor);

        this._controlAdapter = controlAdapter;
        this._windowHalfX = 300;
        this._windowHalfY = 300;

        this._dragEvent = {
            type: 'canvasDrag',
            dragStart: 'beforeDrag',
            dragging: 'dragging',
            dragEnd: 'finishDrag'
        };

        this._enabled = false;

        var scope = this;

        var movement = {
            horizontal: 0,
            vertical: 0
        };

        var movementCopy = {
            horizontal: 0,
            vertical: 0
        };

        //define different events based on the device
        var touchStartEvent = window.navigator.msPointerEnabled ? 'MSPointerDown' : 'touchstart';
        var touchMoveEvent = window.navigator.msPointerEnabled ? 'MSPointerMove' : 'touchmove';
        var touchEndEvent = window.navigator.msPointerEnabled ? 'MSPointerUp' : 'touchend';

        var touchStartEvent = window.navigator.pointerEnabled ? 'pointerdown' : touchStartEvent;
        var touchMoveEvent = window.navigator.pointerEnabled ? 'pointermove' : touchMoveEvent;
        var touchEndEvent = window.navigator.pointerEnabled ? 'pointerup' : touchEndEvent;

        this._initialize = function() {
            if (this._controlAdapter) {
                this._controlAdapter._domElement = this._domElement;
            }

            //adjust the style for the viewer element if we are on IE10 surface
            if (typeof this._domElement.style.msTouchAction !== 'undefined') {
                this._domElement.style.msTouchAction = 'none';
            }

            this._windowHalfX = this._domElement.clientWidth / 2;
            this._windowHalfY = this._domElement.clientHeight / 2;

            if (AtlasClientCapabilities.getCapabilities().eventListener) {
                this._domElement.addEventListener('contextmenu', function(event) {
                    event.preventDefault();
                }, false);
                this._domElement.addEventListener('mousedown', onMouseDown, true);
                this._domElement.addEventListener(touchStartEvent, onTouchStart, true);
            } else {
                document.attachEvent('oncontextmenu', function(event) {
                    return false;
                });
                document.attachEvent('onmousedown', onMouseDown);
            }

            this._enabled = true;
        };

        this.reset = function() {
            if (this._controlAdapter) {
                this._controlAdapter.reset();
            }
        };

        this.disable = function() {
            this._enabled = false;
        };

        this.enable = function() {
            this._enabled = true;
        };

        this.setOnBeforeMouseMove = function(callback) {
            this._onBeforeMouseMove = callback;
        };

        this.setOnBeforeTouchMove = function(callback) {
            this._onBeforeTouchMove = callback;
        };

        this.setOnBeforeMouseDown = function(callback) {
            this._onBeforeMouseDown = callback;
        };

        this.setOnBeforeTouchDown = function(callback) {
            this._onBeforeTouchDown = callback;
        };

        this.setOnBeforeMouseUp = function(callback) {
            this._onBeforeMouseUp = callback;
        };

        this.setOnBeforeTouchEnd = function(callback) {
            this._onBeforeTouchEnd = callback;
        };


        this.setOnBeforeMouseOut = function(callback) {
            this._onBeforeMouseOut = callback;
        };

        this.clickDrag = function(clientX, clientY) {
            this._controlAdapter.end(clientX, clientY);
            this._controlAdapter.begin(clientX, clientY);
        };

        function onMouseDown(e) {
            if (scope._hideCursor && AtlasClientCapabilities.getCapabilities().jqueryAvailable) {
                jQuery('#' + scope._dragElement.id).css('cursor', 'none');
            }

            scope._windowHalfX = scope._dragElement.clientWidth / 2;
            scope._windowHalfY = scope._dragElement.clientHeight / 2;

            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                //IE7 and 8
                e.returnValue = false;
            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }
            else {
                //IE7 and 8
                e.cancelBubble = true;
            }

            if (scope._onBeforeMouseDown) {
                if (!scope._onBeforeMouseDown(e.clientX, e.clientY)) {
                    return false;
                }
            }

            if (!scope._enabled) {
                return false;
            }

            scope._controlAdapter.begin(e.clientX, e.clientY);
            if (AtlasClientCapabilities.getCapabilities().eventListener) {
                scope._dragElement.addEventListener('mouseup', onMouseUp, true);
                scope._dragElement.addEventListener('mousemove', onMouseMove, true);
                scope._dragElement.addEventListener('mouseout', onMouseOut, true);
            } else {
                document.attachEvent('onmouseup', onMouseUp);
                document.attachEvent('onmousemove', onMouseMove);
                document.attachEvent('onmouseout', onMouseOut);
            }

            return false;
        }

        function onMouseUp(e) {
            if (scope._hideCursor && AtlasClientCapabilities.getCapabilities().jqueryAvailable) {
                jQuery('#' + scope._dragElement.id).css('cursor', 'arrow');
            }

            scope._windowHalfX = scope._domElement.clientWidth / 2;
            scope._windowHalfY = scope._domElement.clientHeight / 2;

            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                e.returnValue = false;
            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }
            else {
                //IE7 and 8
                e.cancelBubble = true;
            }

            if (!scope._enabled) {
                return false;
            }

            if (scope._onBeforeMouseUp) {
                if (!scope._onBeforeMouseUp(e.clientX, e.clientY)) {
                    return false;
                }
            }

            if (AtlasClientCapabilities.getCapabilities().eventListener) {
                scope._dragElement.removeEventListener('mouseup', onMouseUp, true);
                scope._dragElement.removeEventListener('mousemove', onMouseMove, true);
                scope._dragElement.removeEventListener('mouseout', onMouseOut, true);
            } else {
                document.detachEvent('onmouseup', onMouseUp);
                document.detachEvent('onmousemove', onMouseMove);
                document.detachEvent('onmouseout', onMouseOut);
            }

            scope.reset();

            return false;
        }

        function onMouseMove(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                e.returnValue = false;
            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }
            else {
                //IE7 and 8
                e.cancelBubble = true;
            }

            if (!scope._enabled) {
                return false;
            }

            if (scope._onBeforeMouseMove) {
                if (!scope._onBeforeMouseMove(e.clientX, e.clientY)) {
                    return false;
                }
            }

            scope._controlAdapter.end(e.clientX, e.clientY);
            scope._controlAdapter.begin(e.clientX, e.clientY);

            return false;
        }

        function onMouseOut(e) {
            var tag, //the tag of the element that sent the mouse out event
                relatedTag; //the tag of the element that the mouse is currently on

            if (!e) {
                e = window.event;
            }

            //tag = (window.event) ? e.srcElement : e.target;

            //if we are not on a DIV element then return and handle throught event bubbling
            //if (tag.nodeName != 'DIV') 
            //    return;

            relatedTag = (e.relatedTarget) ? e.relatedTarget : e.toElement;

            while ((relatedTag) && (relatedTag !== scope._dragElement) && (relatedTag.nodeName !== 'BODY')) {
                relatedTag = relatedTag.parentNode;
            }

            if (!relatedTag || relatedTag.nodeName === 'BODY') {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                else {
                    e.returnValue = false;
                }

                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                else {
                    //IE7 and 8
                    e.cancelBubble = true;
                }

                if (!scope._enabled) {
                    return false;
                }

                if (scope._onBeforeMouseOut) {
                    if (!scope._onBeforeMouseOut(e.clientX, e.clientY)) {
                        return false;
                    }
                }

                if (AtlasClientCapabilities.getCapabilities().eventListener) {
                    scope._dragElement.removeEventListener('mouseup', onMouseUp, true);
                    scope._dragElement.removeEventListener('mousemove', onMouseMove, true);
                    scope._dragElement.removeEventListener('mouseout', onMouseOut, true);
                } else {
                    document.detachEvent('onmouseup', onMouseUp);
                    document.detachEvent('onmousemove', onMouseMove);
                    document.detachEvent('onmouseout', onMouseOut);
                }

                scope.reset();

                return false;
            }
        }

        function onTouchStart(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }

            if (!e.changedTouches && e.touches) {
                e.changedTouches = e.touches;
            }

            //if a single touch, or MSSurface
            if ((e.changedTouches && e.changedTouches.length === 1) || !e.changedTouches) {
                var tx = e.changedTouches ? e.changedTouches[0].pageX : e.screenX;
                var ty = e.changedTouches ? e.changedTouches[0].pageY : e.screenY;


                if (!scope._enabled) {
                    return false;
                }

                var x = tx - scope._windowHalfX;
                var y = ty - scope._windowHalfY;

                if (scope._onBeforeTouchDown) {
                    if (!scope._onBeforeTouchDown(x, y)) {
                        return false;
                    }
                }

                scope._controlAdapter.begin(x, y);

                if (AtlasClientCapabilities.getCapabilities().eventListener) {
                    scope._dragElement.addEventListener(touchMoveEvent, onTouchMove, true);
                    scope._dragElement.addEventListener(touchEndEvent, onTouchEnd, true);
                }
                else {
                    document.attachEvent('on' + touchMoveEvent, onTouchMove);
                    document.attachEvent('on' + touchEndEvent, onTouchEnd);
                }
            }

            return false;
        }

        function onTouchMove(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }

            if (!e.changedTouches && e.touches) {
                e.changedTouches = e.touches;
            }

            //if a single touch, or MSSurface
            if ((e.changedTouches && e.changedTouches.length === 1) || !e.changedTouches) {
                var tx = e.changedTouches ? e.changedTouches[0].pageX : e.screenX;
                var ty = e.changedTouches ? e.changedTouches[0].pageY : e.screenY;


                if (!scope._enabled) {
                    return false;
                }

                var x = tx - scope._windowHalfX;
                var y = ty - scope._windowHalfY;

                if (scope._onBeforeTouchMove) {
                    if (!scope._onBeforeTouchMove(x, y)) {
                        return false;
                    }
                }

                scope._controlAdapter.end(x, y);
                scope._controlAdapter.begin(x, y);
            }

            return false;
        }

        function onTouchEnd(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }

            if (!e.changedTouches && e.touches) {
                e.changedTouches = e.touches;
            }

            if ((e.changedTouches && e.changedTouches.length === 1) || !e.changedTouches) {
                var tx = e.changedTouches ? e.changedTouches[0].pageX : e.screenX;
                var ty = e.changedTouches ? e.changedTouches[0].pageY : e.screenY;

                if (!scope._enabled) {
                    return false;
                }

                var x = tx - scope._windowHalfX;
                var y = ty - scope._windowHalfY;

                if (scope._onBeforeTouchEnd) {
                    if (!scope._onBeforeTouchEnd(x, y)) {
                        return false;
                    }
                }

                if (AtlasClientCapabilities.getCapabilities().eventListener) {
                    scope._dragElement.removeEventListener(touchMoveEvent, onTouchMove, true);
                    scope._dragElement.removeEventListener(touchEndEvent, onTouchEnd, true);
                }
                else {
                    document.detachEvent('on' + touchMoveEvent, onTouchMove);
                    document.detachEvent('on' + touchEndEvent, onTouchEnd);
                }

                scope.reset();
            }

            return false;
        }

        this._initialize();
    };

    return AtlasControls;
});
